import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import CategoriesList from '@app/components/manage-categories/list';

const CategoriesPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('categories.view')}</PageTitle>
      <CategoriesList />
    </>
  );
};

export default CategoriesPage;
